module.exports = __webpack_public_path__ + "img/inventory_mobile.5a9baac5.webp";